import { chain, createSwitcherGroup } from '@leprecoins/effector';
import { createEvent, sample } from 'effector';
import { or } from 'patronum';
import { shiftModel } from 'entities/shift';
import { breakpoints } from 'shared/lib';
import { router } from 'shared/routing';

const createLayoutSwitcher = createSwitcherGroup();

const navbarSwitcher = createLayoutSwitcher();

const asideSwitcher = createLayoutSwitcher();

const $modalsOpened = or(navbarSwitcher.$active, asideSwitcher.$active);

const $openedGames = shiftModel.activatedGameRoute.$isOpened;

const closeModals = createEvent();

sample({
	clock: closeModals,
	target: [navbarSwitcher.disable, asideSwitcher.disable],
});

chain(breakpoints.sm, asideSwitcher.disable);

chain(router.$path, closeModals);

export const cashierLayoutModel = {
	$modalsOpened,
	$openedGames,
	navbarSwitcher,
	asideSwitcher,
	closeModals,
};
